/*global Flickity, OFFICE_INFO */
void (function main() {
	'use strict';

	const menuToggle = (selector) => {
		const toggle = document.querySelector(selector);
		if (toggle) {
			toggle.addEventListener('click', function onClick(e) {
				const menu = document.getElementById(this.dataset.id);
				if (menu) {
					menu.classList.toggle('active');
				}
				e.preventDefault();
			});
		}
	};

	window.urlParams = {
		read() {
			return sessionStorage.url_params
				? JSON.parse(sessionStorage.getItem('url_params'))
				: {};
		},
		write() {
			const storedParams = this.read();
			const queryParams = new URLSearchParams(window.location.search);
			queryParams.forEach((value, key) => {
				storedParams[key] = value;
			});
			sessionStorage.setItem('url_params', JSON.stringify(storedParams));
			return storedParams;
		},
		clear() {
			sessionStorage.url_params = JSON.stringify({});
			return sessionStorage.url_params;
		},
	};

	const loadExternalScript = (props) => {
		if (document.getElementById(props.id)) return;
		const script = document.createElement('script');
		script.src = props.src;
		script.id = props.id;
		document.body.appendChild(script);
		if (props.callback)
			window.addEventListener('load', () => props.callback());
	};

	const initializeCarousels = (selector) => {
		const carousels = document.querySelectorAll(selector);
		if (!carousels.length) return;
		const carouselOptions = {
			cellAlign: 'left',
			adaptiveHeight: true,
			contain: true,
			wrapAround: false,
			pageDots: false,
			selectedAttraction: 0.1,
			friction: 0.5,
			groupCells: true,
			imagesLoaded: true,
			arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 40, x3: 35 },
		};
		const loop = () => {
			for (let i = carousels.length - 1; i >= 0; i--) {
				const makeCarousel = () =>
					new Flickity(carousels[i], carouselOptions);
				makeCarousel();
			}
		};
		loadExternalScript({
			id: 'flickityExternal',
			src: 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js',
			callback: loop,
		});
	};

	function setToday(selector) {
		const wrapper = document.querySelector(selector);
		if (!wrapper) {
			return;
		}

		const d = new Date();
		const day = d.getDay();
		const dayElement = wrapper.querySelector(`.day[data-day="${day}"]`);
		if (dayElement) {
			dayElement.classList.add('current');
		}
	}

	/* AJAX form handler */
	function formCaptureLegacy(formID) {
		/* Legacy form handler */
		const form = document.getElementById(formID);
		if (!form) return;

		// Append the form status
		const formStatus = document.createElement('div');
		formStatus.classList.add('form-status', 'alert');
		form.appendChild(formStatus);

		form.onsubmit = function onSubmit(e) {
			e.preventDefault();

			// Collect the form data while iterating over the inputs
			const data = {};
			for (let i = 0, ii = form.length; i < ii; ++i) {
				const input = form[i];
				data[input.name] = input.value;
			}

			// Disable existing form
			form.parentElement.classList.add('submitted');

			// Construct an HTTP request
			const xhr = new XMLHttpRequest();
			xhr.open(form.method, form.action, true);
			xhr.setRequestHeader('Accept', 'application/json; charset=utf-8');
			xhr.setRequestHeader(
				'Content-Type',
				'application/json; charset=UTF-8',
			);

			// Send the collected data as JSON
			xhr.send(JSON.stringify(data));

			// Callback function
			xhr.onloadend = function onLoadEnd(response) {
				const failedStatus = 0;
				const badRequestStatus = 400;
				const successStatus = 200;
				if (
					response.target.status === failedStatus ||
					response.target.status === badRequestStatus
				) {
					// Failed XmlHttpRequest should be considered an undefined error.
					formStatus.classList.add('error');
					formStatus.innerHTML = form.dataset.errorUnknown;
				} else if (response.target.status === successStatus) {
					// Success
					formStatus.classList.add('success');
					formStatus.innerHTML = form.dataset.success;
				}
			};
		};
	}

	// Alert system
	function displayAlerts() {
		/* eslint-disable camelcase */
		const { alert_message, alert_type } = OFFICE_INFO;
		if (alert_type && alert_message) {
			const header = document.querySelector('body > header');
			const bar = `<div class="global_alerts"><div class="alert ${alert_type}" role="alert"><div class="text">${alert_message}</div></div></div>`;
			header.insertAdjacentHTML('beforebegin', bar);
		}
		/* eslint-enable camelcase */
	}

	// Mapbox
	const mapBoxStatic = (mapBlock) => {
		/* eslint-disable camelcase */
		const { latitude, longitude, mapbox_api_key } = OFFICE_INFO;
		if (!mapBlock) {
			return;
		}
		if (!(window.OFFICE_INFO && latitude && longitude)) {
			return;
		}
		// brandColor - expects hex value.
		const brandColor = getComputedStyle(document.documentElement)
			.getPropertyValue('--color-primary')
			.split('#')[1];

		const mapMode =
			getComputedStyle(document.documentElement)
				.getPropertyValue('--theme-colormode')
				.trim() === 'dark'
				? 'dark-v10'
				: 'streets-v10';
		function getMapImage(size) {
			const s = size ? size : '480x480'; // or "480x480@2x"
			const zoom = '15';
			const pitch = '26';
			const bearing = '0';
			return `https://api.mapbox.com/styles/v1/mapbox/${mapMode}/static/pin-m-heart+${brandColor}(${longitude},${latitude})/${longitude},${latitude},${zoom},${bearing},${pitch}/${s}?access_token=${mapbox_api_key}`;
		}

		const mapContainer = mapBlock.querySelector('.static-map');
		if (!mapContainer) {
			return;
		}
		const output = `<a href="/directions/map/">
			<img
				src="${getMapImage('480x480')}"
				srcset="${getMapImage('480x480')} 480w, ${getMapImage(
					'960x480',
				)} 960w, ${getMapImage('1200x480')} 1200w, ${getMapImage(
					'1200x480@2x',
				)} 2400w"
				alt="Map showing the location of our office" loading="lazy" />
			</a>`;
		mapContainer.insertAdjacentHTML('afterbegin', output);
		/* eslint-enable camelcase */
	};

	function loadPreview() {
		if (window.location.hostname.match(/^.*\.amazonaws\.com$/i)) {
			const script = document.createElement('script');
			script.async = true;
			script.src = '/scripts/preview.min.js';
			document.body.appendChild(script);
		}
	}

	function setTodaysHours(hoursBlock) {
		const officeHours = window.OFFICE_INFO.office_hours;
		const d = new Date();
		const today = d.getDay();
		hoursBlock.insertAdjacentHTML(
			'afterbegin',
			'<h4>Today&rsquo;s Hours</h4>',
		);
		const todaysHours = officeHours[today].isClosed
			? `<div>Closed</div>`
			: `<div>${officeHours[today].dayOfWeekAbbr} ${officeHours[today].opens} &ndash; ${officeHours[today].closes}</div>`;
		hoursBlock.insertAdjacentHTML('beforeend', todaysHours);
	}

	function setChecked() {
		const tabs = document.querySelectorAll('[id^=tab-input-]');
		for (let i = 0; i < tabs.length; i++) {
			document.getElementById(`tab-label-${i.toString()}`).className =
				tabs[i].checked ? 'selected' : '';
		}
	}

	function esteemPromoForm() {
		const form = document.querySelector('#esteem-form');
		if (!form) return;

		let currentGroup = 0;
		const fadeOutTime = 150;
		const fadeInTime = 250;

		// Fade in animation
		function fadeIn(el) {
			setTimeout(() => {
				el.style.display = 'block';
			}, fadeOutTime);
			setTimeout(() => {
				el.style.opacity = 100;
			}, fadeInTime);
		}

		// Fade out animation
		function fadeOut(el) {
			el.style.opacity = 0;
			setTimeout(() => {
				el.style.display = 'none';
			}, fadeOutTime);
		}

		// Show current form group and modify form buttons
		function showFormGroup(n) {
			const formGroups = form.querySelectorAll('.form-group');
			if (formGroups.length === 0) return;
			fadeIn(formGroups[n]);
			if (n === 0) {
				form.querySelector('#previous-button').style.display = 'none';
			} else {
				form.querySelector('#previous-button').style.display = 'inline';
			}
			if (n === formGroups.length - 1) {
				form.querySelector('#next-button').innerHTML = 'Submit';
			} else {
				form.querySelector('#next-button').innerHTML =
					`<svg class="next-arrow" viewBox="0 0 100 100">
					<path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) ">
					</path></svg>`;
			}
		}

		// Validate text forms
		function validateForm(formGroup) {
			const textFields = formGroup.querySelectorAll('.field-text');
			if (textFields.length === 0) return true;

			let valid = true;
			for (let i = 0; i < textFields.length; i++) {
				if (textFields[i].querySelector('input').value === '') {
					textFields[i].querySelector('.error-text').innerHTML =
						'*Field Required';
					valid = false;
				} else {
					textFields[i].querySelector('.error-text').innerHTML = '';
				}
			}
			return valid;
		}

		const esteemFormSubmit = () => {
			const data = {
				esteemFormData: [],
			};

			// Capture radio inputs
			const radioInputs = form.querySelectorAll(
				"input[type='radio']:checked",
			);
			for (let i = 0; i < radioInputs.length; i++) {
				data.esteemFormData.push({
					question: radioInputs[i].name,
					answer: radioInputs[i].value,
				});
			}

			// Capture text inputs
			const textInputs = form.querySelectorAll(
				"input[type='text'], input[type='email'], input[type='tel']",
			);
			for (let i = 0; i < textInputs.length; i++) {
				data.esteemFormData.push({
					question: textInputs[i].name,
					answer: textInputs[i].value,
				});
			}

			form.querySelector('#contact-info').style.display = 'none';
			form.querySelector('#form-submitted').style.display = 'block';
			form.querySelector('.form-nav').style.display = 'none';

			console.log(data);
		};

		// Show next or previous form group
		function nextPrevFormGroup(n) {
			const formGroups = form.querySelectorAll('.form-group');
			if (formGroups.length === 0) return;

			if (n === 1 && !validateForm(formGroups[currentGroup])) return;

			const prevGroup = currentGroup;
			currentGroup = currentGroup + n;

			if (currentGroup >= formGroups.length) {
				// submit form code
				esteemFormSubmit();
				return;
			}

			fadeOut(formGroups[prevGroup]);
			showFormGroup(currentGroup);
		}

		const formClickListeners = () => {
			const nextButton = form.querySelector('#next-button');
			if (nextButton) {
				nextButton.addEventListener('click', () => {
					nextPrevFormGroup(1);
				});
			}
			const prevButton = form.querySelector('#previous-button');
			if (prevButton) {
				prevButton.addEventListener('click', () => {
					nextPrevFormGroup(-1);
				});
			}
			const formRadios = form.querySelectorAll('.field-radio');
			if (formRadios) {
				for (let i = 0; i < formRadios.length; i++) {
					formRadios[i].addEventListener('click', () => {
						formRadios[i].querySelectorAll('input')[0].checked =
							true;
					});
				}
			}
		};

		formClickListeners();
		showFormGroup(currentGroup);
	}

	function doctorNav() {
		const links = document.querySelectorAll('[href^="#dr"]');
		for (const link of links) {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const t = document.querySelector(e.target.hash);
				t.scrollIntoView();
				return false;
			});
		}
		const topLinks = document.querySelectorAll('[href="#top"]');
		for (const topLink of topLinks) {
			topLink.addEventListener('click', (e) => {
				e.preventDefault();
				window.scrollTo(0, 0);
				return false;
			});
		}
	}

	// Function to modify the iframe once it's added
	function makeIframeAccessible(iframe) {
		if (iframe && !iframe.hasAttribute('title')) {
			iframe.setAttribute('title', 'Live Chat');
			iframe.setAttribute('aria-label', 'Live Chat');
		}
	}

	// Observe changes in the document body
	const iframeObserver = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node.tagName === 'IFRAME') {
					// Modify the iframe if it matches the live chat (e.g., by checking src)
					if (node.src.includes('incontact')) {
						makeIframeAccessible(node);
					}
				}
			});
		});
	});

	document.addEventListener('DOMContentLoaded', () => {
		menuToggle('#menutoggle');
		formCaptureLegacy('compactForm');
		setToday('.page-footer .hours');
		displayAlerts();
		loadPreview();
		initializeCarousels('.carousel');
		window.urlParams.write();
		esteemPromoForm();
		doctorNav();

		const welcomeHoursBlock = document.querySelector('#welcome-hours');
		if (window.OFFICE_INFO.office_hours && welcomeHoursBlock) {
			setTodaysHours(welcomeHoursBlock);
		}

		const staticMapList = document.querySelectorAll(
			'.map-blocks, .map-about',
		);
		for (const map of staticMapList) mapBoxStatic(map);

		const footerMap = document.querySelector('.page-footer .map');
		mapBoxStatic(footerMap);

		const commonIssueTabs = document.querySelectorAll(
			'.tab-container input[id^=tab-input-]',
		);
		for (const tab of commonIssueTabs)
			tab.addEventListener('change', setChecked);

		iframeObserver.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
	window.addEventListener('load', () => {
		document.querySelectorAll('iframe').forEach((iframe) => {
			if (iframe.src.includes('incontact')) {
				makeIframeAccessible(iframe);
			}
		});
	});
})();
